module.exports = __webpack_public_path__ + "assets/img/game_quit.14ba7026.png";